<template>
  <div class="px-4 py-3 space-y-6">
    <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 py-4 mb-2">
      <h1 class="text-xl font-semibold text-gray-800">Paramètres</h1>
    </div>

    <!-- Menu des onglets -->
<!-- Menu des onglets -->
 <div class="text-center">
  <section
  class="w-full px-4 py-2 bg-gray-100 inline-flex gap-2 rounded-full overflow-x-auto scrollbar-hide -mx-4 sm:mx-0 sm:justify-center"
>
  <div
    v-for="tab in tabs"
    :key="tab"
    @click="activeTab = tab"
    :class="[
      'px-6 py-2 rounded-full cursor-pointer transition-colors whitespace-nowrap flex-shrink-0',
      activeTab === tab ? 'bg-white text-gray-800 shadow' : 'text-gray-500 hover:bg-white'
    ]"
  >
    {{ tab }}
  </div>
</section>
 </div>



    <!-- Contenu selon l'onglet actif -->
    <div class="mt-6 space-y-4">


      <div v-if="activeTab === 'Sécurité'">
       
       <SecuriteView />
      </div>

            <div v-if="activeTab === 'Compte'">
        <AccountView />
       
      </div>

      <div v-if="activeTab === 'Notifications'">
       <NotificationsView />
      </div>



    </div>
  </div>
</template>

<script>
import AccountView from '@/components/SettingsTabs/AccountView.vue';
import NotificationsView from '@/components/SettingsTabs/NotificationsView.vue';
import SecuriteView from '@/components/SettingsTabs/SecuriteView.vue';
export default {
    components: { NotificationsView, AccountView, SecuriteView },
  data() {
    return {
      tabs: [
       
        "Sécurité",
         "Compte",

       
       
      ],
      activeTab: "Compte"
    };
  }
};
</script>

<style scoped>
/* Pour un défilement horizontal si les onglets dépassent */
section::-webkit-scrollbar {
  display: none;
}
section {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
